import React from 'react';
import { useTranslation } from 'react-i18next'
import iconAccessories from 'assets/m_icon_accessories.jpg';
import iconIntro from 'assets/m_icon_introduction.jpg';
import iconPlano from 'assets/m_icon_plano.jpg';
import iconPos from 'assets/m_icon_pos.jpg';
import iconRules from 'assets/m_icon_rules.jpg';

function MerchandisingPage() {
  const { t } = useTranslation();
  return (
    <div className="merchandising links-page">
      <div className="container">
        <div className="grid">
          <div className="col-2 m-col-1">
          </div>
          <div className="col-2 m-col-3">
            <h1>{t('Merchandising')}</h1>
            <h2>{t('merchandising.subtitle')}</h2>
            <div className="links">
              <a download href="/files/01-TISSOT-VM-GUIDELINE-INTRODUCTION.pdf">
                <img src={iconIntro} alt=""/>
                {t('Introduction')}
              </a>
              <a download href="/files/02-TISSOT-VM-GUIDELINE-BASIC-RULES.pdf">
                <img src={iconRules} alt=""/>
                {t('Basic rules')}
              </a>
              <a download href="/files/03-TISSOT-VM-GUIDELINE-PLANOGRAMS.pdf">
                <img src={iconPlano} alt=""/>
                {t('Planograms')}
              </a>
              <a download href="/files/04-TISSOT-VM-GUIDELINE-ACCESSORIES.pdf">
                <img src={iconAccessories} alt=""/>
                {t('Accessories')}
              </a>
              <a download href="/files/05-TISSOT-VM-GUIDELINE-POS-MATERIAL.pdf">
                <img src={iconPos} alt=""/>
                {t('POS Material')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
}

export default MerchandisingPage
